import React from "react";
import utils from "../../../utils/utils";
import { Link, useNavigate } from "react-router-dom";

import { message, Spin } from "antd";
import "./otp.css";
import { useState } from "react";
import {
  _addUserName,
  _authenticateUser,
  _setUserData,
} from "../../../redux/actions/authAction";
import { Row, Col } from "react-bootstrap";
import InputField from "../../../components/resusable/inputField/InputField";
import ButtonComponent from "../../../components/resusable/button/authButton";
import AuthScreensLayout from "../../../components/resusable/layout/authScreensLayout";
import {
  userLogin,
  verifyUserOtp,
} from "../../../components/https/authentication";
import { errorRequestHandel, isValidEmailAddress } from "../../../helper";
import { useDispatch, useSelector } from "react-redux";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import { _addUserProfileData } from "../../../redux/actions/profileSettingsAction";

function OtpScreen() {
  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    otp: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputFocus = (fieldName) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const dispatch = useDispatch();
  const { user_name, reset_password, password, is_otp } = useSelector(
    (state) => state.auth.userNameData
  );

  const [otp, setOtp] = useState(""); // Initialize with 4 empty strings

  const handleOtp = async () => {
    if (otp === "") {
      setErrors({ ...errors, otp: "Otp is required" });
      return;
    }

    const payload = {
      user_name: user_name,
      // password: password,
      // firebase_token: "xef",
      otp: otp,
      // is_otp: 1,
    };

    const userNamePayload = {
      reset_password: true,
      user_name: user_name,
      otp: otp,
    };

    try {
      setLoading(true);
      const response = await verifyUserOtp(payload);
      if (response.status === 200) {
        if (reset_password === false) {
          const loginPayload = {
            user_name: user_name,
            password: password,
            is_otp: 0,
            firebase_token: "XYZ",
          };
          const result = await userLogin(loginPayload);

          localStorage.setItem("user", JSON.stringify(result?.data?.data));
          dispatch(_authenticateUser(true));
          dispatch(_setUserData(result?.data?.data));
          dispatch(_addUserProfileData(result.data.data));

          navigate("/");
        } else {
          dispatch(_addUserName(userNamePayload));
          navigate("/reset-password");
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  return (
    <AuthScreensLayout
      cloudImage={utils.images.forgetPasswordCloud}
      cloudHeading="Cloud Based"
      cloudDescription="Promotes access to information at the point of care. Improves the process of analysis and decision making."
      imageWidth={220}
    >
      <div className="otp_form_container">
        <img
          src={utils.icons.Dentalid_logo}
          height={17}
          width={200}
          alt="logo"
        />
        <h4>OTP</h4>
        <p>Enter a 6 digit OTP we sent on your email address.</p>
        <div
          className={
            errors.otp === ""
              ? "otp_field_container"
              : "otp_field_container_error"
          }
        >
          <input
            id={`otp-input-${1}`}
            type="text"
            name={otp}
            value={otp}
            maxLength="6"
            onChange={(event) => setOtp(event.target.value)}
            style={{ textAlign: "start", padding: "5px 10px" }}
            onFocus={() => handleInputFocus("otp")}
          />
        </div>
        <div className="text-danger">
          <span>{errors.otp}</span>
        </div>
        <div>
          <CustomPrimaryButton
            title="Verify"
            onClick={handleOtp}
            width={"100%"}
            isLoading={loading}
          />
          {/* <ButtonComponent performClick={handleOtp} text="Verify" /> */}
        </div>
        <div>
          Already have an account?
          <Link to="/login">
            <span> Sign In</span>
          </Link>
        </div>
      </div>
    </AuthScreensLayout>
  );
}

export default OtpScreen;
